import ProfileForm from '@/app/components/features/userSettings/ProfileForm';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/(organization)/_layout/settings/_layout/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ProfileForm />;
}
